// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/campaign-custom-field-schema',
  type: 'object',
  required: ['appSystemId'],
  nullable: true,
  properties: {
    id: {
      type: 'string',
      nullable: true,
    },
    appSystemId: {
      type: 'integer',
    },
    caption: {
      type: 'string',
      nullable: true,
    },
    type: {
      type: 'string',
      nullable: true,
    },
  },
} as IJSONSchema;

export default schema;
